module.exports = __webpack_public_path__ + "static/Polylang-5eaaae877e55100c07bf17ca6caaf24a.jpg";